import { Theme as MuiTheme } from '@mui/material/styles';
import { ProductDocument } from './containers/products/types';

// TODO: make styled components expect theme as a property instead of using type casting
export type Theme = MuiTheme

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export enum PlanListItemSource {
  Youtube = 'youtube',
  Instagram = 'instagram',
  Pinterest = 'pinterest',
  TikTok = 'tiktok',
}

export interface PlanListItem {
  id: number;
  title: string;
  alternativeTitle: string | null;
  description: string;
  imgUrl: string;
  publishedAt: string;
  authorName: string; // TODO: not there sometimes
  source: PlanListItemSource | null;
  materialsCost: string | null;
  materialsCostCurrency: Currencies;
}

export interface VendorListItem {
  id: number;
  name: string;
  bio: string;
  imgUrl: string;
}

export interface PlanImageItem {
  id: number;
  imgUrl: string;
  title: string;
  rank: number;
}

export interface PlanDocumentItem {
  planId: number;
  id: number;
  fileUrl: string;
  name: string;
}

export interface ProductImageItem {
  id: number;
  imgUrl: string;
  title: string;
  rank: number;
}

export interface InstructionVideoItem {
  id: number;
  youtubeId: string;
  instagramId: string;
  source: string;
  key: string;
  videoUrl?: string;
}

export interface ResourceListItem {
  id: number;
  imgUrl: string;
  name: string;
  description: string;
  quantity: string;
  uom: string;
  isTool: boolean;
  isOptional: boolean;
  isHeavyTool: boolean;
  toolId: number;
}

export interface CompanyDetails {
  name: string;
  bio: string;
  imgUrl: string;
}

export interface OrderListItem {
  id: number;
  status: OrderStatus;
  itemsCount: number;
  vendorName: string;
  vendorImgUrl: string;
  additionalInfo?: string;
  createdAt: string;
}

export interface OrderDetails extends OrderListItem {
  isOrderReceiptSent: boolean;
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  phone: string;
  customerAddress1: string;
  customerAddress2: string;
  customerCity: string;
  customerState: string;
  customerPostalCode: string;
  customerPhone: string;
  vendorAddress: string;
  vendorTaxId: string;
  currency: Currencies;
  plan: PlanListItem;
  products: OrderProduct[];
  additionalFees: QuickOrderAdditionalFee[];
}

export interface Message {
  content: string;
  companyId: number;
  authorId: number;
  authorName: string;
  isAutomatic?: boolean; 
  createdAt: string;
}

/**deprecated use OrderStatus2 enum instead */
export enum OrderStatus {
  Created = 'created',
  Prepared = 'prepared',
  Paid = 'paid',
  Shipped = 'shipped',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
}

export interface OrderStatusChangePayload {
  id: number;
  status: OrderStatus;
}

export type OrderProduct = {
  id: number;
  isBundle: boolean;
  bundleProductId: number | null;
  quickOrderId: number;
	resourceId: number;
  orderId: number;
	productId: number;
	name: string;
	sku: string;
	description: string;
	pricePerUnit: string;
	quantity: string;
	uom: string;
	imgUrl?: string;
	notes?: string;
  documents: ProductDocument[];
  images: {imgUrl: string, title: string, id: number}[];
};

export type QuickOrderProduct = {
  id: number;
  quickOrderId: number;
  productId: number;
  name: string;
  sku: string;
  description: string;
  pricePerUnit: string;
  quantity: string;
  resourceId: number;
  uom: string;
  imgUrl?: string;
  digitalDelivery?: boolean; // <- virtual property
  documentsCount?: number; // <- virtual property
  images: {imgUrl: string, title: string, id: number}[];
  bundleProductId: number | null;
  isBundle: boolean;
};

export interface QuickOrder {
  id: number;
  title: string;
  vendorId: number;
}

export interface QuickOrderListItem {
  id: number;
  title: string;
  vendorId: number;
  vendor: {
    id: number;
    name: string;
    imgUrl: string;
    currency: Currencies;
    company: {
      name: string;
      profileId: string;
      coverImgUrl: string;
    };
  };
  materialsCost: string;
  currency: Currencies;
  planId: number;
  plan: PlanListItem;
  products: QuickOrderProduct[];
  additionalFees: QuickOrderAdditionalFee[];
  shippingRegions: string[];
  publishedAt: string | null;
}

export interface QuickOrderInfo {
  id: number;
  title: string;
  isBundle: boolean;
  planId: number;
  vendorId: number;
  vendor: {
    id: number;
    name: string;
    imgUrl: string;
    vendorContactEmail?: string;
    currency: Currencies;
    company: {
      name: string;
      profileId: string;
      coverImgUrl: string;
    };
  };
  products: QuickOrderProduct[];
  resources: ResourceListItem[];
  additionalFees: QuickOrderAdditionalFee[];
  plan: PlanListItem;
  publishedAt: string | null;
  shippingRegions: string[];
  materialsCost: string;
  currency: Currencies;
  extendsFrom: QuickOrderInfo | null;
}

export enum FeeType {
	Percentage = 'percentage',
	Fixed = 'fixed',
}

export interface QuickOrderAdditionalFee {
  id: number;
  vendorId: number;  
  quickOrderId: number;
  name: string;
  price: string;
  description?: string;
  type: FeeType;
}

export enum Currencies {
  EUR = 'eur',
  USD = 'usd',
  GBP = 'gbp'
}

export const CURRENCY_SYMBOLS = {
	[Currencies.EUR]: '€',
	[Currencies.USD]: '$',
	[Currencies.GBP]: '£'
};

export enum OrderStatus2 {
  Pending = 'prepared',
  Paid = 'paid',
}

export interface PlanHint {
  id: number;
  title: string;
  description: string;
  email: string;
  isAuthor: boolean;
}

export interface Tag {
  id: number;
  name: string;
  isApproved: boolean;
}

export interface PlanAd {
  id: number;
  planId: number;
  description: string;
  createdAt: string;
  isPublished: boolean;
}

export interface PlanAdListItem {
  id: number;
  planId: number;
  companyId: number;
  companyName: string;
  companyImgUrl: string;
  website: string;
  description: string;
  isEmailFormEnabled: boolean;
}

export interface CompanyPlanAdListItem extends PlanAdListItem {
  isPublished: boolean;
}
